import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { updateSessionToken, checkSessionStatus } from './api';
import { fetchInitialData, fetchCountryTaxTypeDescriptions } from './store/actions';
import { periodOrCurrentSelector } from './store/selectors';
import { PeriodPropTypes } from './propTypes/period';

import AccessDeniedPage from './pages/accessDeniedPage/accessDenied.component';
import Spinner from './spinner.component';
import { isSameOrAfterToday } from './dateHelpers';
import getCookie from './../utils/getCookie';

class InitialDataProvider extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    isInitialDataLoaded: PropTypes.bool.isRequired,
    isUserActive: PropTypes.bool,
    lastClientId: PropTypes.number,
    clients: PropTypes.arrayOf(PropTypes.shape({
      clientId: PropTypes.number.isRequired,
      expirationDate: PropTypes.string,
    })),
    period: PeriodPropTypes,
    fetchInitialData: PropTypes.func.isRequired,
    fetchCountryTaxTypeDescriptions: PropTypes.func.isRequired,
  };

  async componentDidMount() {
    try {
      const validToken = getCookie('validToken');
      if (!validToken) {
        await checkSessionStatus();
        document.cookie = 'validSessionToken=true; path=/';
      }
    } catch (error) {
      return;
    }

    const { token } = await updateSessionToken();
    window.sessionStorage.setItem('sessionToken', token);

    this.props.fetchInitialData();
    if (this.props.period) {
      this.props.fetchCountryTaxTypeDescriptions(this.props.period);
    }
  }

  componentDidUpdate(prevProps) {
    const { period } = this.props;
    const prevPeriodName = prevProps.period && prevProps.period.name;
    if (period && prevPeriodName !== period.name) {
      this.props.fetchCountryTaxTypeDescriptions(period);
    }
  }

  // review if the lastClientId is expired
  isLastClientExpired = () => {
    const { lastClientId, clients } = this.props;
    const lastClient = clients.find(client => client.clientId === lastClientId);
    return !isSameOrAfterToday(lastClient.expirationDate);
  };

  render() {
    const {
      isInitialDataLoaded,
      isUserActive,
    } = this.props;
    if (!isInitialDataLoaded) {
      return <Spinner global />;
    }

    if (!isUserActive || this.isLastClientExpired()) {
      return <AccessDeniedPage />;
    }

    return <div>{this.props.children}</div>;
  }
}

export default withRouter(connect(state => ({
  isInitialDataLoaded: state.shared.isInitialDataLoaded,
  isUserActive: state.user.user && state.user.user.isActive,
  lastClientId: state.user.user && state.user.user.lastClientId,
  clients: state.user.user && state.user.clients,
  period: periodOrCurrentSelector(state),
}), {
  fetchInitialData,
  fetchCountryTaxTypeDescriptions,
})(InitialDataProvider));
